import { View } from "@/classes/inbox/View";
import { orderBy, query, Query, where } from "firebase/firestore";
import { UserStore } from "@/store/constants";
import { store } from "@/store";

export class ViewAssigned extends View {
  constructor() {
    super("Deine Konversationen");
  }

  async getQuery(): Promise<Query> {
    return query(
      this.defaultQuery,
      where("operator", "==", store.getters[UserStore.Getters.UID]),
      orderBy("updated", "desc")
    );
  }
}
